import { Box, FormControl, Grid, InputLabel, MenuItem, Select, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import SkySparkGrid from '../../api/SkySparkGrid'
import { ResponsiveBar } from '@nivo/bar'
import { ResponsivePie } from '@nivo/pie'
import InfLoader from '../../infLoad'

const OpeningTimesChart = ({ dateRange, pointList }) => {
    const { siteId } = useParams()
    const [selectedPoint, setSelectedPoint] = useState(pointList[0].id.val)
    const [chartData, setChartData] = useState([])
    const [chartLoading, setChartLoading] = useState(true)
    const [chartPointName, setChartPointName] = useState(pointList[0].id.dis)
    const [pieChartData, setPieChartData] = useState([])

    const HandlePointChange = (e) => {
        setSelectedPoint(e.target.value)
        setChartPointName(pointList.find((point) => point['id']['val'] === e.target.value)['id']['dis'])
    }

    useEffect(() => {
        if(!chartLoading) setChartLoading(true)
        SkySparkGrid(`api_profileScheduleUsage(@${siteId}, @${selectedPoint}, ${dateRange})`).then((response) => {
            if (response.data !== null && response.data["rows"] !== null && response.data["rows"].length !== 0) {
                setChartData(response.data)
                setChartLoading(false)
                setPieChartData([
                    {
                        id: response.data['cols'].find((col) => col['name'] === 'valueIn')['meta']['dis'],
                        label: response.data['cols'].find((col) => col['name'] === 'valueIn')['meta']['dis'],
                        value: response.data['meta']['usageInPerc'],
                        valueInTotal: response.data['meta']['usageInTotal'],
                        color: response.data['cols'].find((col) => col['name'] === 'valueIn')['meta']['color']
                    },
                    {
                        id: response.data['cols'].find((col) => col['name'] === 'valueOut')['meta']['dis'],
                        label: response.data['cols'].find((col) => col['name'] === 'valueOut')['meta']['dis'],
                        value: response.data['meta']['usageOutPerc'],
                        valueInTotal: response.data['meta']['usageOutTotal'],
                        color: response.data['cols'].find((col) => col['name'] === 'valueOut')['meta']['color']
                    }
                ])
            } else {
                setChartLoading(false)
                setChartData([])
            }
        })
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [siteId, dateRange, selectedPoint])

    useEffect(() => {
        setSelectedPoint(pointList[0].id.val)
        setChartPointName(pointList[0].id.dis)
    }, [pointList])

    return (
        <Grid container gap={2} wrap="nowrap" sx={{ marginBottom: '15px' }}>
            <Grid item xl={8} xs={8} sx={{ width: '400px', height: '500px', backgroundColor: '#f2f0f0', boxShadow: 3 }}>
                {/* Point selector */}
                <Box sx={{ display: 'flex', justifyContent: 'flex-start', m: '8px' }}>
                    <FormControl sx={{ width: '275px', mt: '8px'}}>
                        <InputLabel shrink={true} sx={{color:'black'}} id="pointSelectorLabel">Selecteer punt</InputLabel>
                        <Select
                            id='point-selector'
                            labelId='pointSelectorLabel'
                            label='Selecteer punt'
                            value={selectedPoint === undefined ? ('') : (selectedPoint)}
                            onChange={(e) => HandlePointChange(e)}
                            sx={{ width: '100%', height: '30px', color: 'black', fontFamily:'Source Sans Pro,sans-serif !important' }}
                        >
                            {pointList.map((point) => <MenuItem key={point.id.val} value={point.id.val}>{point.id.dis}</MenuItem>)}
                        </Select>
                    </FormControl>
                </Box>
                {/* Point name */}
                <Typography textAlign='center' variant='h5' fontWeight='bold' sx={{color:'#141414'}}>Verbruik per dag (binnen en buiten werktijd)</Typography>
                <Typography textAlign='center' variant='h6' sx={{color:'#141414'}}>{chartPointName}</Typography>
                {/* Chart */}
                <Box sx={{width:'100%', height:'95%'}}>
                    {
                        chartLoading || chartData.length === 0 ? (<Box sx={{display:'flex', justifyContent:'center', marginTop:'128px'}}><InfLoader/></Box>) : (
                        <ResponsiveBar
                            data={chartData["rows"]}
                            keys={chartData["meta"]["cols"]}
                            indexBy="id"
                            margin={{ top: 30, right: 130, bottom: 135, left: 80 }}
                            padding={0.3}
                            valueScale={{ type: 'linear' }}
                            indexScale={{ type: 'band', round: true }}
                            colors={point => chartData["cols"].find((row) => row["name"] === point.id)["meta"]["color"]}
                            tooltip={(point) => {
                                const pointName = chartData["cols"].find(col => col["name"] === point.id)["meta"]["dis"]
                                const unit = chartData["cols"].find(col => col["name"] === point.id)["meta"]["unit"]
                                return (
                                    <Box sx={{ backgroundColor: "white", color: "black", padding: "10px", borderRadius: "5px", boxShadow:3, opacity:0.9, display:'flex'}}>
                                         <Box sx={{width:'10px', height:'20px', backgroundColor: point.color, margin:'auto', marginRight:'9.9px', borderRadius:'3px'}}></Box>
                                         <Typography sx={{marginTop:'1px'}}>{pointName}: {Math.round(point.formattedValue)}{unit}</Typography>
                                    </Box>
                                )
                            }}
                            axisTop={null}
                            axisRight={null}
                            axisBottom={{
                                tickSize: 7,
                                tickPadding: 5,
                                tickRotation: 30,
                                legendPosition: 'middle',
                                legendOffset: 32,
                                truncateTickAt: 0
                            }}
                            axisLeft={{
                                format: (value) => `${value} ${chartData["meta"]["unit"]}`,
                                tickSize: 5,
                                tickPadding: 5,
                                tickRotation: 0,
                                legendPosition: 'middle',
                                legendOffset: -40,
                                truncateTickAt: 0
                            }}
                            label={false}
                            legends={[
                                {
                                    dataFrom: 'keys',
                                    data: chartData["meta"]["cols"].map((id) => ({
                                        id,
                                        color: chartData["cols"].find((row) => row["name"] === id)["meta"]["color"],
                                        label: chartData["cols"].find((row) => row["name"] === id)["meta"]["dis"]
                                    })),
                                    anchor: 'bottom-right',
                                    direction: 'column',
                                    justify: false,
                                    translateX: 120,
                                    translateY: 0,
                                    itemsSpacing: 2,
                                    itemWidth: 100,
                                    itemHeight: 20,
                                    itemDirection: 'left-to-right',
                                    itemOpacity: 0.85,
                                    symbolSize: 20,
                                    effects: [
                                        {
                                            on: 'hover',
                                            style: {
                                                itemOpacity: 1
                                            }
                                        }
                                    ]
                                }
                            ]}
                            role="application"
                        />)
                    }
                </Box>
            </Grid>
            <Grid item xl={4} xs={4} sx={{ height: '500px', backgroundColor: '#f2f0f0', boxShadow: 3 }}>
                {
                    chartLoading || chartData.length === 0 ? (<Box sx={{display:'flex', justifyContent:'center', marginTop:'230px'}}><InfLoader/></Box>) : (
                    <Box sx={{widht:'100%', height:{xl:'87%', lg:'80%', md:'70%', sm:'70%', xs:'70%'}}}>
                    <Typography textAlign='center' variant='h5' sx={{marginTop:'16px'}} fontWeight='bold'>Procentueel Verbruik per dag (binnen en buiten werktijd)</Typography>
                    <Typography textAlign='center' variant='h6'>{chartPointName}</Typography>
                    <ResponsivePie
                        data={pieChartData}
                        colors={row => row.data.color}
                        margin={{ top: 40, right: 130, bottom: 80, left: 130 }}
                        innerRadius={0.5}
                        valueFormat={(value) => value + '%'}
                        padAngle={0.7}
                        cornerRadius={3}
                        activeOuterRadiusOffset={8}
                        tooltip={(point) => {
                            return (
                                <Box sx={{ backgroundColor: "white", color: "black", padding: "10px", borderRadius: "5px", boxShadow:3, opacity:0.9, display:'flex'}}>
                                    <Box sx={{width:'10px', height:'40px', backgroundColor: point.datum.color, margin:'auto', marginRight:'9.9px', borderRadius:'3px'}}></Box>
                                    {point.datum.label}: {point.datum.formattedValue} <br/>
                                    Verbruik {point.datum.label}: {Math.round(point.datum.data.valueInTotal.val)} {point.datum.data.valueInTotal.unit}
                                </Box>
                            )
                        }}
                        borderWidth={1}
                        arcLinkLabelsSkipAngle={10}
                        arcLinkLabelsTextColor="#333333"
                        arcLinkLabelsThickness={2}
                        arcLabelsSkipAngle={10}                    
                        legends={[
                            {
                                anchor: 'bottom',
                                direction: 'row',
                                justify: false,
                                translateX: 0,
                                translateY: 56,
                                itemsSpacing: 10,
                                itemWidth: 100,
                                itemHeight: 18,
                                itemTextColor: '#999',
                                itemDirection: 'left-to-right',
                                itemOpacity: 1,
                                symbolSize: 18,
                                symbolShape: 'circle',
                                effects: [
                                    {
                                        on: 'hover',
                                        style: {
                                            itemTextColor: '#000'
                                        }
                                    }
                                ]
                            }
                        ]}
                    />
               </Box>
                    )
                }
            </Grid>
        </Grid>
    )
}

export default OpeningTimesChart
